<template>
  <v-card>
    <div class="d-flex justify-space-between pa-4 pb-0">
      <v-card-title class="small-title">{{ title }}</v-card-title>
      <div class="font-weight-light grey--text">Total records: {{ items.length }}</div>
    </div>
    <v-data-table
      class="assignments-table pb-4"
      item-key="id"
      disable-pagination
      hide-default-footer
      :headers="isInvested ? investedHeaders : billableHeaders"
      :items="items"
      :dense="denseTables"
      :sort-by="['employee.name']"
    >
      <template #item="{ item, headers }">
        <template>
          <tr :class="{ shadow:item.role === 'Shadow' }">
            <td
              v-for="(header, index) in headers.filter(h => !h.hidden)"
              :key="index"
            >
              <template v-if="header.value === 'employee.name'">
                {{ item.employee.name }}
              </template>
              <template v-else-if="header.value === 'office_title'">
                {{ item.employee.office_title }}
              </template>
              <template v-else-if="header.value === 'start_date' || header.value === 'end_date'">
                {{ item[header.value] | dateToDisplay(dateFormatSettings) }}
              </template>
              <template v-else-if="header.value === 'ovr_allowed'">
                <v-checkbox
                  :class="`mt-0 pt-0 ${denseTables && 'ripple-scale'}`"
                  color="primary"
                  hide-details
                  :input-value="!!Number(item.settings.ovr_allowed)"
                  @change="assignmentOVRAllowedChanged(item, $event)"
                />
              </template>
              <template v-else>
                {{ item[header.value] }}
              </template>
            </td>
          </tr>
        </template>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import { DateHelper } from '@/helpers/date.helper';
import apiClient from '@/services/api-client';

export default {
  filters: {
    dateToDisplay: DateHelper.formatDateAccordingSettings,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: 'Invested employees',
    },
    isInvested: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      investedHeaders: [
        {
          text: 'Name',
          value: 'employee.name',
        },
        {
          text: 'Office',
          value: 'office_title',
          fixed: true,
          width: '1%',
          sortable: false,
        },
        {
          text: 'As.',
          value: 'assignment',
          fixed: true,
          width: '1%',
          sortable: false,
        },
        {
          text: 'Billable status',
          value: 'billable_status',
          fixed: true,
          width: '150px',
          sortable: false,
        },
        {
          text: 'Start Date',
          value: 'start_date',
          fixed: true,
          width: '120px',
          sortable: false,
        },
        {
          text: 'End Date',
          value: 'end_date',
          fixed: true,
          width: '120px',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          fixed: true,
          width: '1%',
          sortable: false,
        },
        {
          text: 'OVR',
          value: 'ovr_allowed',
          width: '1%',
          sortable: false,
        },
      ],
      billableHeaders: [
        {
          text: 'Name',
          value: 'employee.name',
        },
        {
          text: 'Position',
          value: 'position',
          sortable: false,
        },
        {
          text: 'Office',
          value: 'office_title',
          fixed: true,
          width: '1%',
          sortable: false,
        },
        {
          text: 'As.',
          value: 'assignment',
          fixed: true,
          width: '1%',
          sortable: false,
        },
        {
          text: 'Start Date',
          value: 'start_date',
          fixed: true,
          width: '120px',
          sortable: false,
        },
        {
          text: 'End Date',
          value: 'end_date',
          fixed: true,
          width: '120px',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          fixed: true,
          width: '1%',
          sortable: false,
        },
        {
          text: 'OVR',
          value: 'ovr_allowed',
          width: '1%',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user/settings', [
      'denseTables',
      'dateFormatSettings',
    ]),
    ...mapGetters('projects/main', ['search']),
  },
  methods: {
    ...mapMutations('projects/main', ['setProjectAssignments']),

    async assignmentOVRAllowedChanged(assignment, ovr_allowed) {
      ovr_allowed = !!ovr_allowed;
      const previousOVRAllowedValue = assignment.settings.ovr_allowed;

      this.$set(assignment.settings, 'ovr_allowed', ovr_allowed);

      try {
        await apiClient.projectApi.setProjectAssignmentSettings(
          assignment.project_id, assignment.id,
          { ovr_allowed },
        );
        this.$store.cache.delete('auth/account/getUserProjects');
      } catch (error) {
        this.flashError('An error occured while requesting "OVR allowed" setting updating for assignment.');
        this.$set(assignment.settings, 'ovr_allowed', previousOVRAllowedValue);
      }
    },
  },
};
</script>

<style lang="less">
  .assignments-table {
    overflow: auto;

    .ripple-scale.v-input--selection-controls:not(.v-input--switch) .v-input--selection-controls__ripple {
      transform: scale(0.6);
    }

    table .shadow {
      color: darkgray;
    }
  }
</style>
